import { createContext } from 'react';

const registroContext = createContext();

export default registroContext;